module.exports = __webpack_public_path__ + "v294910/img/icon-search.6952bcb4.png";